$(document).ready(function () {
  if ($(".employee-grid-section").length) {
    $(".employee-grid-section [class^='col-'].about-1341 a").click(function(e) {
      event.preventDefault();
    });
  }
});